import ComplianceManager from "./compliance-manager";
export default ComplianceManager;